var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSortDesc = function SvgSortDesc(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.928589 4.37145L4.77716 0.522879C4.80596 0.492802 4.84056 0.468867 4.87886 0.452516C4.91716 0.436164 4.95837 0.427734 5.00002 0.427734C5.04166 0.427734 5.08288 0.436164 5.12118 0.452516C5.15948 0.468867 5.19407 0.492802 5.22287 0.522879L9.07145 4.37145",
    stroke: "#1B2031",
    strokeOpacity: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.928589 7.62891L4.77716 11.4775C4.80596 11.5076 4.84056 11.5315 4.87886 11.5478C4.91716 11.5642 4.95837 11.5726 5.00002 11.5726C5.04166 11.5726 5.08288 11.5642 5.12118 11.5478C5.15948 11.5315 5.19407 11.5076 5.22287 11.4775L9.07145 7.62891",
    stroke: "#CF410D",
    strokeOpacity: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSortDesc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-desc.ffc431cf7f097953527cf50e930a98c6.svg";